import React, { Component, Fragment, createRef } from 'react';
import { connect } from 'react-redux';
import { Field } from 'react-final-form-html5-validation';
import { OnChange } from 'react-final-form-listeners';
import * as actions from '../../actions';
import {
    isRequiredPhoneNumber,
    isRequiredQuestionSelection,
    isRequiredText,
    numberValidator,
    isRequired
} from '../helpers/Validation';
import { textField } from '../helpers/Form';

class Step2 extends Component {
    
    constructor(props) {
        super(props)
        this.state = {
          insuranceStatus: null
        }
    }

    phoneTwo = createRef();
    phoneThree = createRef();
    cardholderPhoneTwo = createRef();
    cardholderPhoneThree = createRef();

    render() {
        const { currentStep } = this.props; 
        const { 
            insuranceStatus,
            cardholderPhoneOne,cardholderPhoneTwo,
            cardholderPhoneThree,
            phoneOne,
            phoneTwo,
            phoneThree 
        } = this.props.questionOptions; 

        return (
            <Fragment>
                <div className="row mobile-step-header">
                    <div className="col-sm-2 col-2">
                        <span className="header-number">{currentStep}</span>
                    </div>
                    <div className="col-sm-10 col-10 pl-0">
                        <h3 className="euclid">INSURANCE INFORMATION</h3>
                        <div className="d-inline-block"><i>All questions are required unless marked optional.</i></div>
                        <div className="text-right d-inline-block float-right pr-2">*required</div>
                    </div>
                    <div class="row grey-spacer-col-1"></div>
                </div>
                
                <div className="row spacer-medium">&nbsp;</div>
                    <Field className="form-control" name="insuranceStatus" component="input" defaultValue={insuranceStatus} validate={isRequiredQuestionSelection}>
                        {({ input, meta }) => (
                            <Fragment>
                                <label className={meta.error && meta.touched ? "fancy-label error" : "fancy-label"} htmlFor="state" style={{paddingBottom: '9px'}}>Insurance status*</label>
                            </Fragment>
                        )}
                    </Field>
                    
    
                    <div className="form-group">
                        <div class="row">
                            <div class="col-sm">
                                <div className="radio-field">
                                    <Field name="insuranceStatus" type="radio">
                                        {({ input, meta }) => {
                                            return(
                                                <Fragment>
                                                    <input
                                                        id="insuranceStatusYes"
                                                        name={input.name}
                                                        type="radio"
                                                        onClick={(e) => this.props.questionAnswer("insuranceStatus", "yes")}
                                                    />
                                                    <label htmlFor="insuranceStatusYes">Patient has insurance</label>
                                                </Fragment>);
                                        }}
                                    </Field>
                                </div>
                                <div className="radio-field">
                                    <Field name="insuranceStatus" type="radio">
                                        {({ input, meta }) => {
                                            return(
                                                <Fragment>
                                                    <input
                                                        id="insuranceStatusNo"
                                                        name={input.name}
                                                        type="radio"
                                                        onClick={(e) => this.props.questionAnswer("insuranceStatus", "no")}
                                                    />
                                                    <label htmlFor="insuranceStatusNo">Patient does not have insurance</label>
                                                </Fragment>);
                                        }}
                                    </Field>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col">
                                <Field className="form-control" name="insuranceStatus" component="input" defaultValue={insuranceStatus} validate={isRequiredQuestionSelection}>
                                    {({ input, meta }) => (
                                        <Fragment>
                                            <input {...input} type="text" className="form-control full-width-input hidden-field" tabindex="-1" />
                                            {meta.error && meta.touched && meta.error}
                                        </Fragment>
                                    )}
                                </Field>
                            </div>
                        </div>
                    </div>

                {insuranceStatus === "yes" && (
                    <Fragment>
                        <div className="row spacer-medium">&nbsp;</div>
                        <Field
                            name="prescriptionDrugPlan"
                            label="Prescription drug plan*"
                            component={textField}
                            validate={isRequiredText}
                        />
                        <div className="row">
                            <div class="col-sm-6">
                                <Field name="phoneNumber" component="input" defaultValue={phoneOne + phoneTwo + phoneThree} validate={isRequiredPhoneNumber}>
                                    {({ input, meta }) => (
                                        <Fragment>
                                            <label className={meta.error && meta.touched ? "error" : "fancy-label"} htmlFor="phoneNumber" > Phone number* </label> 
                                        </Fragment>
                                    )}
                                </Field>
                                <div className="phone-group">
                                    <Field name="phoneOne" component="input" validate={isRequired}>
                                        {({ input, meta }) => (
                                            <Fragment>
                                                <input 
                                                    {...input} 
                                                    className={meta.error && meta.touched ? "form-control inline-phone phone-area-code error" : "form-control inline-phone phone-area-code"}
                                                    type="text"
                                                    maxLength="3"
                                                    placeholder="123"
                                                />
                                                {meta.error && meta.touched && meta.error }
                                            </Fragment>
                                        )}
                                    </Field>
                                    <OnChange name="phoneOne">
                                        {(value, previous) => {
                                            if(numberValidator(value)) {
                                                this.props.questionAnswer("phoneOne", value);
                                                if(value.length === 3) {
                                                    this.phoneTwo.current.focus();
                                                }               
                                            }       
                                        }}
                                    </OnChange>
                                    <Field name="phoneTwo" component="input" validate={isRequired} >
                                        {({ input, meta }) => (
                                            <Fragment>
                                                <input 
                                                    {...input}
                                                    className={meta.error && meta.touched ? "form-control inline-phone phone-prefix error" : "form-control inline-phone phone-prefix"}
                                                    type="text"
                                                    maxLength="3"
                                                    placeholder="456"
                                                    ref={this.phoneTwo} 
                                                />
                                                {meta.error && meta.touched && meta.error }
                                            </Fragment>
                                        )}
                                    </Field>
                                    <OnChange name="phoneTwo">
                                        {(value, previous) => {
                                            if(numberValidator(value)) {
                                                this.props.questionAnswer("phoneTwo", value);
                                                if(value.length === 3) {
                                                    this.phoneThree.current.focus();
                                                } 
                                            }
                                        }}
                                    </OnChange>
                                    <Field name="phoneThree" component="input" validate={isRequired}>
                                        {({ input, meta }) => (
                                            <Fragment>
                                                <input 
                                                className={meta.error && meta.touched ? "form-control inline-phone phone-line-number error" : "form-control inline-phone phone-line-number"}
                                                {...input} type="text" maxLength="4" placeholder="7890" ref={this.phoneThree} />
                                                {meta.error && meta.touched && meta.error }
                                            </Fragment>
                                        )}
                                    </Field>
                                    <OnChange name="phoneThree">
                                        {(value, previous) => {     
                                            if(numberValidator(value)) {
                                                this.props.questionAnswer("phoneThree", value);
                                            }
                                        }}
                                    </OnChange>
                                    <Field name="phoneNumber" component="input" defaultValue={phoneOne + phoneTwo + phoneThree} validate={isRequiredPhoneNumber}>
                                        {({ input, meta }) => (
                                            <Fragment>
                                                <input {...input} type="text" className="form-control full-width-input hidden-field" tabindex="-1" />
                                                {meta.error && meta.touched && meta.error }
                                            </Fragment>
                                        )}
                                    </Field>
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <Field
                                    name="idNumber"
                                    label="ID Number*"
                                    component={textField}
                                    validate={isRequiredText}
                                />
                            </div>

                        </div>
                        <div className="row spacer-small">&nbsp;</div>
                        <div className="row">
                            <div className="col-sm-6">
                                <Field
                                    name="planNumber"
                                    label="Plan number (optional)"
                                    component={textField}
                                />
                            </div>
                            <div className="col-sm-6">
                                <Field
                                    name="groupNumber"
                                    label="Group number (optional)"
                                    component={textField}
                                />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm">
                                <Field
                                    name="pcnBinNumber"
                                    label="PCN/BIN number (optional)"
                                    component={textField}
                                    customDivClass={{marginBottom: '0px'}}
                                />
                            </div>
                            <div className="row spacer-large mobile-sm">&nbsp;</div>
                            <div class="col-sm">
                                <Field
                                    name="cardholderName"
                                    label="Cardholder Name (optional)"
                                    component={textField}
                                />
                            </div>
                        </div>
                                            

                        <div className="row">
                            <div className="col-sm-6">
                                <label className="fancy-label" style={{marginBottom: '0px'}}>Cardholder phone number (optional)</label>
                                <div className="phone-group">
                                    <Field name="cardholderPhoneOne" component="input">
                                        {({ input, meta }) => (
                                            <Fragment>
                                                <input
                                                    className="form-control inline-phone phone-area-code"
                                                    {...input}
                                                    type="text"
                                                    maxLength="3"
                                                    placeholder="123"
                                                    inputMode="numeric"    
                                                />
                                                {meta.error && meta.touched && meta.error }
                                            </Fragment>
                                        )}
                                    </Field>
                                    <OnChange name="cardholderPhoneOne">
                                        {(value, previous) => {
                                            this.props.questionAnswer("cardholderPhoneOne", value);
                                            if(value.length === 3) {
                                                console.log("this.phoneTwo.current", this.cardholderPhoneTwo.current);
                                                this.cardholderPhoneTwo.current.focus();
                                            }                      
                                        }}
                                    </OnChange>
                                    <Field name="cardholderPhoneTwo" component="input" >
                                        {({ input, meta }) => (
                                            <Fragment>
                                                <input
                                                    className="form-control inline-phone phone-prefix"
                                                    {...input}
                                                    type="text"
                                                    maxLength="3"
                                                    placeholder="456"
                                                    ref={this.cardholderPhoneTwo}
                                                    inputMode="numeric"
                                                />
                                                {meta.error && meta.touched && meta.error }
                                            </Fragment>
                                        )}
                                    </Field>
                                    <OnChange name="cardholderPhoneTwo">
                                        {(value, previous) => {
                                            this.props.questionAnswer("cardholderPhoneTwo", value);
                                            if(value.length === 3) {
                                                console.log("this.phoneTwo.current", this.cardholderPhoneThree.current);
                                                this.cardholderPhoneThree.current.focus();
                                            } 
                                        
                                        }}
                                    </OnChange>
                                    <Field name="cardholderPhoneThree" component="input">
                                        {({ input, meta }) => (
                                            <Fragment>
                                                <input
                                                    className="form-control inline-phone phone-line-number"
                                                    {...input}
                                                    type="text"
                                                    maxLength="4"
                                                    placeholder="7890"
                                                    ref={this.cardholderPhoneThree}
                                                    inputMode="numeric"
                                                />
                                                {meta.error && meta.touched && meta.error }
                                            </Fragment>
                                        )}
                                    </Field>
                                    <OnChange name="cardholderPhoneThree">
                                        {(value, previous) => {            
                                            this.props.questionAnswer("cardholderPhoneThree", value);
                                        }}
                                    </OnChange>
                                </div>
                                <Field name="cardholderPhoneNumber" component="input" defaultValue={cardholderPhoneOne + cardholderPhoneTwo + cardholderPhoneThree}>
                                    {({ input, meta }) => (
                                        <Fragment>
                                            <input {...input} type="text" className="form-control full-width-input hidden-field" tabindex="-1" />
                                            {meta.error && meta.touched && meta.error }
                                        </Fragment>
                                    )}
                                </Field>
                            </div>
                            <div className="col-sm-6">
                                <Field
                                    name="relationshipToCardholder"
                                    label="Relationship to cardholder (optional)"
                                    component={textField}
                                />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm">
                                <Field
                                    name="medicareBeneficiaryID"
                                    label="Medicare beneficiary ID (optional)"
                                    component={textField}
                                />
                            </div>
                            <div class="col-sm">
                                <Field
                                    name="insurancePreferredLanguage"
                                    label="Preferred language, if not English (optional)"
                                    component={textField}
                                />
                            </div>
                        </div>
                    </Fragment>
                )}
            </Fragment>
        )
    }
}


const mapStateToProps = (state) => {
    const { currentStep, questionOptions } = state;
    return { currentStep: currentStep, questionOptions: questionOptions };
}
export default connect(mapStateToProps, actions)(Step2);